<div class="flex">

    <!-- image -->
    <div class="m-r-3"
         [style.minWidth.px]="60">
        <a class="w-12"
           [class.giftcardItemImage]="item.isGiftcard"
           [ngClass]="item.isGiftcard ? 'ratio-3-2' : 'ratio-3-4'"
           [routerLink]="product.data?.url">
            <img class="rf"
                 [options]="item.isGiftcard ? {} : {fitIn: true}"
                 [image]="image">
        </a>
    </div>

    <!-- name & price -->
    <div class="flex-grow">
        <div class="flex flex-justify-between">
            <a class="s2"
               [attr.sl-minibasket-item-name]="item.id"
               [routerLink]="product?.data?.url">{{product?.data.name}}</a>
            <div class="flex flex-column p2">
                @if (item.orgPrice) {
                <price precision='2'
                       class="block col-12 line-through price m-r-1 m-r-0-s"
                       [attr.sl-minibasket-item-orgprice]="item.id"
                       [value]="item.orgPrice"></price>
                }
                <price precision='2'
                       class="block price"
                       [attr.sl-minibasket-item-price]="item.id"
                       [value]="item.price"></price>
            </div>
        </div>
        @if (!item.isGiftcard) {
        <div class="p2">
            @for (option of item.configurableOptions; track trackByConfigurableCode($index, option)) {
            <div class="m-t-1">
                <span class="col-12">
                    {{option.code | attributeLabel }}:
                </span>
                {{option.value | optionLabel : option.code}}
            </div>
            }
        </div>
        }
    </div>
</div>
